import { createSlice } from "@reduxjs/toolkit";
import VwHbsServistanimDTO from "src/models/Settings/Generals/VwHbsServistanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IServisTanim {
    open: boolean;
    activeRow: VwHbsServistanimDTO;
    depoOpen: boolean;
    islemOpen: boolean;
    servisUcretIslemIds: Array<number>;
    yatakOpen: boolean;
};
export const ServisTanimSlice = createSlice<IServisTanim, MapReducerPayloads<IServisTanim, {
    setOpen: boolean;
    setActiveRow: VwHbsServistanimDTO;
    setDepoOpen: boolean;
    setIslemOpen: boolean;
    setServisUcretIslemIds: Array<number>;
    setYatakOpen: boolean;

}>>({
    name: "servisTanim",
    initialState: {
        open: false,
        activeRow: new VwHbsServistanimDTO(),
        depoOpen: false,
        islemOpen: false,
        servisUcretIslemIds: [],
        yatakOpen:false,
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setDepoOpen: (state, action) => {
            state.depoOpen = action.payload;
        },
        setIslemOpen: (state, action) => {
            state.islemOpen = action.payload;
        },
        setServisUcretIslemIds: (state, action) => {
            state.servisUcretIslemIds = action.payload;
        },
        setYatakOpen: (state, action) => {
            state.yatakOpen = action.payload;
        },
    }
});